import type { LandingDomainStatus } from '@/entities/landing.entity';
import { getLandingDomainStatusLabel } from '@/entities/landing.entity';
import { cn } from '@/lib/utils';
import { AlertCircleIcon, BanIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';

const STATUS_CONFIG: Record<
	LandingDomainStatus,
	{ icon: typeof ClockIcon; className: string; pulse?: boolean }
> = {
	waiting_dns: { icon: ClockIcon, className: 'text-chart-5', pulse: true },
	online: { icon: CheckCircleIcon, className: 'text-chart-2' },
	error: { icon: AlertCircleIcon, className: 'text-destructive' },
	disabled: { icon: BanIcon, className: 'text-muted-foreground' },
};

interface LandingDomainStatusBadgeProps {
	status: LandingDomainStatus;
	className?: string;
}

export default function LandingDomainStatusBadge({ status, className }: LandingDomainStatusBadgeProps) {
	const config = STATUS_CONFIG[status];
	const StatusIcon = config.icon;

	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-border bg-background/80 px-2 py-0.5 text-xs font-medium',
				config.className,
				config.pulse && 'animate-pulse',
				className,
			)}
		>
			<StatusIcon size={12} className={config.pulse ? 'animate-spin' : undefined} />
			{getLandingDomainStatusLabel(status)}
		</span>
	);
}
